<template>
  <FileManager></FileManager>
</template>

<script>
import FileManager from "@/components/FileManager";
import {mapActions} from "vuex";
export default {
  name: "FileManagerView",
  components: {FileManager},
  mounted()
  {
    this.setPageTitle('مدیریت فایل ها');
    this.setShowHead(true);
    this.setPageLoading(false);
  },
  methods: {
    ...mapActions('app', {
      setPageTitle: 'setPageTitle',
      setPageLoading: 'setPageLoading',
      setShowHead: 'setShowHead'
    }),
  }
}
</script>

<style scoped>

</style>